import { render, staticRenderFns } from "./ProductsPriceTags.vue?vue&type=template&id=1eadfec2&scoped=true&"
import script from "./ProductsPriceTags.vue?vue&type=script&lang=js&"
export * from "./ProductsPriceTags.vue?vue&type=script&lang=js&"
import style0 from "./ProductsPriceTags.vue?vue&type=style&index=0&id=1eadfec2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eadfec2",
  null
  
)

export default component.exports